<template>
  <div>
    <header class="banner">
      <yd-slider autoplay="4000">
        <yd-slider-item v-for="item in bannerList" :key="item.ID">
          <img
            :src="item.ImagePath?item.ImagePath+'?x-oss-process=image/resize,m_fill,h_140,w_375':defaultImgAct+'?x-oss-process=image/resize,m_fill,h_140,w_375'"
            :onerror="defaultImgAct+'?x-oss-process=image/resize,m_fill,h_140,w_375'" alt>
        </yd-slider-item>
      </yd-slider>
    </header>
    <ul class="menu clearfix">
      <li>
        <router-link :to="{ path: '/policyKnow'}">
          <i></i>
          <span>政知道</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name:'study-list'}">
          <i></i>
          <span>研习社</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name:'aboutUS'}">
          <i></i>
          <span>协会简介</span>
        </router-link>
      </li>
      <li @click="checkApply">
        <i></i>
        <span>会员申请</span>
      </li>
    </ul>
    <section>
      <div class="header clearfix">
        <h5>企业服务体系</h5>
      </div>
      <div class="server-system">
        <ul class="label-two clearfix" :class="{'auto':isShowAll}">
          <li v-for="item in serviceSystem" :key="item.ID" @click="onClickServiceSystemChild(item)">
            {{item.Title}}</li>
        </ul>
        <div class="unfold">
          <span @click="onPull()">
            {{isShowAll?'收起':'展开'}}
            <i :class="{'rotate':isShowAll}"></i>
          </span>
        </div>
      </div>
      <!-- <div class="org-img">
        <img src="@/assets/images/org-img.png" alt="">
      </div>-->
    </section>
    <section>
      <div class="header clearfix">
        <h5>最新活动</h5>
        <div class="more">
          <router-link :to="{name: 'activity-list'}">更多+</router-link>
        </div>
      </div>
      <div style="padding: 0 0.24rem;position: relative;">
        <swiper :options="swiperOption" class="activity-list">
          <!-- class="swiper-no-swiping" -->
          <swiper-slide v-for="item in activeList" :key="item.id">
            <div class="active-item">
              <router-link :to="{name:'activity-detail',params: {id: item.ID}}">
                <div class="img">
                  <!-- +'?x-oss-process=image/resize,m_pad,h_160,w_325,color_000000' -->
                  <img
                    :src="item.TitleImagePath?item.TitleImagePath+'?x-oss-process=image/resize,m_pad,h_320,w_650,color_ffffff':defaultImgAct+'?x-oss-process=image/resize,m_fill,h_160,w_325'"
                    :onerror="defaultImgAct+'?x-oss-process=image/resize,m_fill,h_160,w_325'" alt>
                  <div class="label btn-main">{{item.ActTypeName}}</div>
                </div>
                <div class="info">
                  <h5>{{item.Title}}</h5>
                  <span>时间：{{item.ActivityStartTimeTXT}}</span>
                  <span>地点: {{item.ProvinceName}}{{item.CityName}}</span>
                </div>
              </router-link>
            </div>
          </swiper-slide>
          <div class="swiper-pagination home-banner-dot" slot="pagination"></div>
        </swiper>

        <!-- <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>-->
        <!-- <ul class="activity-list">
          <li v-for="item in activeList">
            <router-link :to="{name:'activityDetails',query: {id: item.ID}}">
              <div class="img">
                <img :src="item.TitleImagePath?item.TitleImagePath+'?x-oss-process=image/resize,m_fill,h_160,w_325':defaultImgAct+'?x-oss-process=image/resize,m_fill,h_160,w_325'"
                  :onerror="defaultImgAct+'?x-oss-process=image/resize,m_fill,h_160,w_325'" alt="">
              </div>
              <div class="info">
                <h5>{{item.Title}}</h5>
                <span>时间：{{item.ActivityStartTimeTXT}}</span>
                <span>地点: {{item.ProvinceName}}{{item.CityName}}</span>
              </div>
            </router-link>
          </li>
        </ul>-->
      </div>
    </section>
    <section>
      <div class="header clearfix">
        <h5>新闻资讯</h5>
        <div class="more">
          <router-link :to="{name: 'newsList'}">更多+</router-link>
        </div>
      </div>
      <ul class="news-list">
        <li v-for="item in newsList" :key="item.ID">
          <router-link :to="{name:'news-detail',params: {id: item.ID}}">
            <div class="img">
              <img class="img"
                :src="item.TitleImagePath !=null?item.TitleImagePath  +'?x-oss-process=image/resize,m_pad,h_132,w_200,color_ffffff':defaultImg"
                :onerror="defaultImg" alt>
            </div>
            <div class="main-content">
              <h5 style="-webkit-box-orient: vertical;">{{item.ContentTitle}}</h5>
              <span>时间：{{item.PublishedTime}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <section>
      <div class="header clearfix">
        <h5>政知道</h5>
        <div class="more">
          <router-link :to="{ name: 'policyKnow'}">更多+</router-link>
        </div>
      </div>
      <ul class="policy-list">
        <li v-for="item in policyList" :key="item.ID">
          <router-link :to="{name:'news-detail',params: {id: item.ID}}">
            <h5>{{item.ContentTitle}}</h5>
            <div class="clearfix">
              <span class="fl">时间：{{item.PublishedTime}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <section class="border-none">
      <div class="header clearfix">
        <h5>研习社资讯</h5>
        <div class="more">
          <router-link :to="{ path:'/study/list'}">更多+</router-link>
        </div>
      </div>
      <ul class="policy-list">
        <li v-for="item in yxsNewsList" :key="item.ID">
          <router-link :to="{name:'news-detail',params: {id: item.ID}}">
            <h5>{{item.ContentTitle}}</h5>
            <div class="clearfix">
              <span class="fl">时间：{{item.PublishedTime}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <footer-logo :height="distanceHeight"></footer-logo>
    <footer-nav :name="name"></footer-nav>
  </div>
</template>

<script>
  import footerNav from '@/views/footerNav.vue'
  import footerLogo from '@/components/footerLogo.vue'
  import VueAwesomeSwiper from 'vue-awesome-swiper'
  import {
    checkMemberApply
  } from '@/js/memberStatusRedirect'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  export default {
    components: {
      swiper,
      swiperSlide,
      'footer-nav': footerNav,
      'footer-logo': footerLogo
    },
    data() {
      return {
        swiperOption: {
          noSwiping: true,
          slidesPerView: 1.1,
          slidesPerGroup: 1,
          paginationClickable: false,
          spaceBetween: 18,
          speed: 2000,
          loop: false,
          observer: false,
          observeParents: false,
          autoplayDisableOnInteraction: false,
          freeModeMomentum: false
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          //   hideOnClick: true,
          //   disabledClass: 'my-button-disabled',
          //   hiddenClass: 'my-button-hidden',
          // },
        },
        name: {
          name: '首页',
          height: 0.99 + 'rem'
        },
        screenHeight: 100,
        distanceHeight: 1.4 + 'rem',
        bodyHeight: document.body.clientHeight,
        bannerList: [],
        isShowAll: false,
        serviceSystem: [],
        activeList: [],
        activeData: {
          activityType: 0,
          pageIndex: 1,
          pageSize: 5
        },
        newsList: [],
        newsData: {
          type: 'EntNews',
          pageIndex: 1,
          pageSize: 3
        },
        policyList: [],
        policyData: {
          type: 'EntPolicy',
          pageIndex: 1,
          pageSize: 3
        },
        yxsNewsList: [],
        yxsNewsData: {
          type: 'YanXS',
          pageIndex: 1,
          pageSize: 3
        },
        defaultImgAct: 'http://image.gongyila.com/org/1/album/2018/09/01d34f33d65440c58d11d1802f3c1cc7.png',
        defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
      }
    },
    computed: {},
    created() {
      this.isIPhone()
      this.getServiceSystem()
      this.getBannerList()
      this.getActList()
      this.getNewsList()
      this.getPolicyList()
      var _this = this
    },
    methods: {
      isIPhone() {
        // var height = 0.99 + "rem";
        var isIphoneX =
          window.devicePixelRatio &&
          window.devicePixelRatio === 3 &&
          window.screen.width === 375 &&
          this.$testUA('iPhone')

        if (isIphoneX) {
          document.body.classList.add('fix-iphonex-bottom')
          this.name.height = this.getHeight().footHeight
          this.distanceHeight = this.getHeight().distanceHeight
        }
      },
      onPull() {
        this.isShowAll = !this.isShowAll
      },
      onClickServiceSystemChild(categoryItem) {
        if (categoryItem.RedirectUrl) {
          this.$router.push({
            path: categoryItem.RedirectUrl
          })
        } else if (categoryItem.CategoryType === 1) {
          // 如果是文章栏目
          this.$router.push({
            path: '/serviceSystem/news/' + categoryItem.CategoryNo
          })
        } else {
          // 如果是内容栏目
          this.$router.push({
            path: '/serviceSystem/' + categoryItem.CategoryNo
          })
        }
      },
      getBannerList() {
        var _this = this
        this.$fetch('/api/Advertise/GetAdvertisementList?anchorNo=App_HomeIndex_Banner').then(
          result => {
            if (result && result.length > 0) {
              _this.bannerList = result
            }
          }
        )
      },
      // 获取服务体系
      getServiceSystem() {
        var _this = this
        this.$fetch('/api/CmsCategory/GetCategories?categoryNo=ServiceSystem').then(result => {
          _this.serviceSystem = result
        })
      },
      checkApply() {
        checkMemberApply(this.$router)
      },
      getActList() {
        var _this = this
        this.activeData.pageIndex = 1
        this.$fetch('/api/Activity/GetActivityList', this.activeData).then(result => {
          if (result.Items && result.Items.length > 0) {
            this.activeList = result.Items
          }
        })
      },
      getNewsList() {
        var _this = this
        this.newsData.pageIndex = 1
        this.$fetch('/api/News/GetNewsList', this.newsData).then(result => {
          this.loadstate = false
          if (result.Items && result.Items.length > 0) {
            this.newsList = result.Items
          }
        })
      },
      getPolicyList() {
        var _this = this
        this.policyData.pageIndex = 1
        this.$fetch('/api/News/GetNewsList', this.policyData).then(result => {
          this.loadstate = false
          if (result.Items && result.Items.length > 0) {
            this.policyList = result.Items
          }
        })
        this.yxsNewsData.pageIndex = 1
        this.$fetch('/api/News/GetNewsList', this.yxsNewsData).then(result => {
          this.loadstate = false
          if (result.Items && result.Items.length > 0) {
            this.yxsNewsList = result.Items
          }
        })
      }
    }
  }

</script>
<style lang="css">
  @import '../assets/css/swiper.min.css';

</style>
<style lang="less" scoped>
  // #foot-fixed {
  //   // padding-bottom: env(safe-area-inset-bottom);
  //   height: 1.2rem !important;
  // }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .banner {
    width: 100%;
    height: 280 / @rem-size;

    img {
      height: 280 / @rem-size;
    }
  }

  .menu {
    width: 702 / @rem-size;
    height: 168 / @rem-size;
    background: #fff;
    margin: auto;
    border-radius: 8 / @rem-size;
    position: relative;
    top: -22 / @rem-size;
    z-index: 200;

    li {
      padding-top: 20 / @rem-size;
      width: 25%;
      height: 100%;
      float: left;
      text-align: center;

      &:active {
        background: #fff - 10%;
      }

      i {
        display: block;
        width: 92 / @rem-size;
        height: 88 / @rem-size;
        background: url('../assets/images/index-menu.png');
        background-size: 368 / @rem-size 88 / @rem-size;
        margin: 0 auto;
      }

      &:nth-child(2) i {
        background-position: -92 / @rem-size 0;
      }

      &:nth-child(3) i {
        background-position: -184 / @rem-size 0;
      }

      &:nth-child(4) i {
        background-position: -276 / @rem-size 0;
      }

      span {
        display: block;
        font-size: 24 / @rem-size;
        margin-top: 15 / @rem-size;
      }
    }
  }

  section {
    width: 100%;
    background: #fff;
    border-bottom: 20 / @rem-size solid #f7f7f7;

    .header {
      width: 100%;
      height: 72 / @rem-size;
      padding: 0 24 / @rem-size;
      border-bottom: 1px solid #e5e5e5;
      line-height: 72 / @rem-size;

      h5 {
        font-size: 32 / @rem-size;
        font-weight: normal;
        float: left;
        padding-left: 24 / @rem-size;
        position: relative;

        &::after {
          content: '';
          display: block;
          width: 4 / @rem-size;
          height: 32 / @rem-size;
          background: #005fd5;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
      }

      .more {
        float: right;
        font-size: 24 / @rem-size;
        color: #999;
      }
    }

    .org-img {
      width: 100%; // height: 694/@rem-size;
    }

    .activity-list {
      width: 100%;
      height: auto;
      // display: flex;
      // -ms-flex-wrap: nowrap;
      // flex-wrap: nowrap;
      // overflow-x: auto;
      padding: 20 / @rem-size 0;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      // li {
      //   position: relative;
      //   margin-right: 24/@rem-size;

      .img {
        width: 650 / @rem-size;
        height: 320 / @rem-size;
        overflow: hidden;
        position: relative;

        .label {
          width: auto;
          height: 40 / @rem-size;
          font-size: 24 / @rem-size;
          text-align: center;
          line-height: 40 / @rem-size;
          position: absolute;
          top: 16 / @rem-size;
          left: 0;
          margin: auto;
          padding: 0 10/@rem-size;
        }

        img {
          width: 100%;
        }
      }

      .info {
        h5 {
          font-size: 0.3rem;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 650 / @rem-size;
          font-weight: 500;
          margin-top: 15 / @rem-size;
        }

        span {
          display: block;
          margin-top: 10 / @rem-size;
          color: #999;
          font-size: 28 / @rem-size;
        }
      }

      // }
    }

    .news-list {
      padding: 0 24 / @rem-size;

      li {
        display: flex;
        margin-top: 25 / @rem-size;
        padding-bottom: 25 / @rem-size;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        .label {
          width: 80 / @rem-size;
          height: 40 / @rem-size;
          font-size: 24 / @rem-size;
          text-align: center;
          line-height: 40 / @rem-size;
          position: absolute;
          top: 16 / @rem-size;
          left: 0;
          margin: auto;
        }

        &:last-child {
          border: none;
        }

        a {
          display: flex;
        }

        .img {
          width: 200 / @rem-size;
          height: 132 / @rem-size;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .main-content {
          flex: 1;
          margin-left: 22 / @rem-size;

          h5 {
            font-size: 0.3rem;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 4.9rem;
            font-weight: 500;
            line-height: 46 / @rem-size;
            max-height: 92 / @rem-size;
          }

          span {
            display: block;
            margin-top: 10 / @rem-size;
            color: #999;
            font-size: 24 / @rem-size;
          }
        }
      }
    }

    .policy-list {
      padding: 0 24 / @rem-size;

      li {
        padding: 15 / @rem-size 0;
        border-bottom: 1px solid #e5e5e5;

        &:last-child {
          border: 0 !important;
        }
      }

      h5 {
        font-size: 0.3rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-weight: 500;
        line-height: 46 / @rem-size;
        max-height: 92 / @rem-size;
        padding-left: 20 / @rem-size;
        position: relative;

        &::after {
          display: block;
          content: '';
          width: 8 / @rem-size;
          height: 8 / @rem-size;
          background: #005fd5;
          position: absolute;
          top: 15 / @rem-size;
          left: 0;
        }
      }

      span {
        font-size: 28 / @rem-size;
        color: #999;
        display: block;
        margin-top: 10 / @rem-size;
        padding-left: 20 / @rem-size;
      }
    }
  }

  .server-system {
    width: 100%;
    height: auto;
    padding: 0 0 24 / @rem-size 24 / @rem-size;

    .label-two {
      height: 178 / @rem-size;
      overflow: hidden;
      padding-top: 13 / @rem-size;

      &.auto {
        height: auto !important;
      }

      li {
        width: 157 / @rem-size;
        height: 55 / @rem-size;
        float: left;
        line-height: 55 / @rem-size;
        text-align: center;
        border: 1px solid #c5defc;
        border-radius: 500px;
        color: #0b6cdd;
        margin-top: 23 / @rem-size;
        margin-right: 27 / @rem-size;
        font-size: 25 / @rem-size;
        // width: 157/@rem-size;
        // height: 55/@rem-size;
        // float: left;
        // background: url('../assets/images/label-bc.png');
        // background-size: 100% 100%;
        // color: #0b6cdd;
        // line-height: 57/@rem-size;
        // text-align: center;
        // padding-left: 26/@rem-size;
        // margin-top: 23/@rem-size;
        // margin-right: 27/@rem-size;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }

    .label-first {
      height: 200 / @rem-size;
      overflow: hidden;

      &.auto {
        height: auto !important;
      }

      li {
        width: 164 / @rem-size;
        height: 80 / @rem-size;
        border: 2 / @rem-size solid #ccdff7;
        text-align: center;
        padding: 8 / @rem-size;
        margin-top: 20 / @rem-size;
        margin-right: 16 / @rem-size;
        float: left;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }

      span {
        display: block;
        line-height: 60 / @rem-size;
        width: 100%;
        height: 100%;
        background: #e5effb;
        font-size: 32 / @rem-size;
        color: #005fd5;
      }
    }

    .unfold {
      text-align: center;
      margin-top: 26 / @rem-size;

      span {
        display: inline-block;
        font-size: 28 / @rem-size;
        color: #999;
        padding-right: 55 / @rem-size;
        position: relative;

        i {
          display: block;
          width: 35 / @rem-size;
          height: 25 / @rem-size;
          background-image: url('../assets/images/pull.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;

          &.rotate {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .border-none {
    border-bottom: 0 !important;
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 58 / @rem-size;
    height: 58 / @rem-size;
    background: url('../assets/images/left-right.png');
    background-size: 120 / @rem-size 60 / @rem-size;
    top: 37%;
  }

  .swiper-button-prev {
    background-position: -60 / @rem-size 0;
  }

  .select-group .distpicker-address-wrapper select {
    // position: absolute;
    width: 31% !important;
    height: 0.88rem !important;
    background: #fff !important;
    border: 1px solid #e6e6e6;
    border-radius: 0.1rem !important;
    -webkit-appearance: none !important;
    padding: 0 0.2rem !important;
    font-size: 0.28rem !important;
    position: relative;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    margin-right: 2%;
    margin-bottom: 0.2rem;
  }

</style>
